// const digitPeriodRegExp = /\d|\./

export function blockInvalidChar (event) {
  if (event.ctrlKey || event.altKey || typeof event.key !== 'string' || event.key.length !== 1) {
    return
  }

  if (!/[\d.]/.test(event.key)) {
    event.preventDefault()
    return
  }

  if (event.key === '.' && event.target.value.includes('.')) {
    event.preventDefault()
  }
}

export const blockInvalidCharInInputNumberField = (e) => {
  const allowedKeys = [
    'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
  ]

  if (
    !/[0-9]/.test(e.key) &&
    !allowedKeys.includes(e.key)
  ) {
    e.preventDefault()
  }
}

export const sendMessageOutsideIframe = (eventName, data = null) => {
  window.parent.postMessage({
    eventName,
    data
  }, '*')
}
